import React, { useState } from 'react';
import { Input } from 'antd';

interface TextProps {
  disabled: boolean;
  value: string;
  onChange: (value: string) => void;
  maxLength?: number;
}

export const Text: React.FC<TextProps> = ({ disabled, value, onChange, maxLength }) => {
  const [editing, setEditing] = useState(false);
  return editing && !disabled ? <Input.TextArea value={value} maxLength={maxLength} onChange={(e) => onChange(e.target.value)} /> : <span onClick={() => !disabled && setEditing(true)}>{value}</span>;
};